import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom";

const DEFAULT_DELAY = 1000;

export default function useTimer ()  {
    const location = useLocation()
    const [timer, setTimer] = useState<{ [name: string]: number }>({});
    const [isRunning, setIsRunning] = useState<{ [name: string]: boolean }>({});
    const noTimerLocationPath = ["/", "/export"];

    const start = (name : string) =>{
        if(Object.keys(timer).indexOf(name) == -1){
            setTimer(timer => ({
                ...timer,
                [name]: 0
            }));
        }

        
        setIsRunning(isRunning => ({
            ...isRunning,
            [name]: true
        }));
    }

    const retreive = (erase : boolean = false) =>{

        if(erase){
            console.log("reset all timers");
            setTimer({});
            setIsRunning({});
            return;
        }

        //Get from localStorage
        //Retrieve Timer if existing
        let strTimer = localStorage.getItem("timer");
        let strTimerRunning = localStorage.getItem("timer_isRunning");


        if(strTimer && strTimerRunning){
            console.log("Retrieve Timer if existing", strTimer, strTimerRunning)
            console.log("retreiveHistory",localStorage.getItem("retreiveHistory"))
            let tempTimer = JSON.parse(strTimer);
            let tempTimerRunning = JSON.parse(strTimerRunning);
            
            //pause all timer at retreive
            /*Object.keys(tempTimer).forEach(k=>{
                tempTimerRunning[k] = false
            })*/
            if(JSON.stringify(tempTimer) != "{}" && JSON.stringify(tempTimerRunning) != "{}"){
                setTimer(tempTimer);
                setIsRunning(tempTimerRunning);
            }
        }
    }

    const pause = (name : string) =>{
        setIsRunning(isRunning => ({
            ...isRunning,
            [name]: false
        }));
    }

    const resume = (name : string) =>{
        setIsRunning(isRunning => ({
            ...isRunning,
            [name]: true
        }));
    }

    const reset = (name : string) =>{
        setTimer(timer => ({
            ...timer,
            [name]: 0
        }));
        setIsRunning(isRunning => ({
            ...isRunning,
            [name]: true
        }));
    }
    
    const get = (name : string) => {
        return timer[name];
    }

    
    useEffect(()=>{
            if(noTimerLocationPath.includes(location.pathname)){
                console.log("No timer in this page");
                return;
            }
            const intervalId = setInterval(() => {
                setTimer(timer => {
                    Object.keys(timer).forEach(k=>{
                        if(isRunning[k]){
                            timer[k]++
                        }
                    })
                    localStorage.setItem("timer", JSON.stringify(timer));
                    localStorage.setItem("timer_isRunning", JSON.stringify(isRunning));
                    return timer;
                })
            },  DEFAULT_DELAY );
            return () => clearInterval(intervalId);
        
        
        
    }, [timer, isRunning])
        
    return {
        start, pause, resume, reset, get, retreive, timer, isRunning
      };
      
}